<template>
    <footer class="footer mt-auto py-3">
      <div class="container">
        <div class="row">
          <div class="col-md-4 align-baseline">
            <p>
              <span class="pr-5">&copy; {{ new Date().getFullYear() }} <router-link to="/imprint-privacy" class="ml-1">Imprint / Privacy</router-link></span>
              <a href="https://www.instagram.com/popular_lifestyle" target="_blank">Instagram</a> /
              <a href="https://www.linkedin.com/company/popular-gmbh" target="_blank">LinkedIn</a>
            </p>
          </div>
          <div class="col-md-4 d-none d-md-block align-baseline">
            <p class="ml-4">
              <router-link to="/careers">Careers</router-link> /
              <router-link to="/csr">CSR</router-link>
            </p>
          </div>
          <div class="col-md-4">
            <slot>
              <div class="row">
                <div class="col">
                  <p>
                    POPULAR GmbH<br>
                    Holstenwall 7<br>
                    20355 Hamburg<br>
                    Germany
                  </p>
                </div>
                <div class="col">
                  <p>
                    STUDIO NX<br>
                    Ballindamm 7<br>
                    20095 Hamburg<br>
                    Germany

<!--                    +49 (0) 40 /<br>-->
<!--                    69 66 66-800<br>-->
<!--                    <br>-->
<!--                    <a href="mailto:contact@popular.de">contact@popular.de</a>-->
                  </p>
                </div>
                <div class="col">
                  <p>
                    SOCIAL CONTENT STUDIO<br>
                    <span class="text-nowrap">Prenzlauer Allee 242</span><br>
                    10405 Berlin<br>
                    Germany
                  </p>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    line-height: 1.1;
  }
  .nav-links {
    font-size: 2rem;
  }
</style>
